module.exports = __webpack_public_path__ + "media/images/visionexpress-9d83ac85b850d9954794386745079bcf.png";